const dictionary = {
  en: {
    locale: 'en',
    messages: {
      hello: 'hello',
      searchPlaceholder: 'search...',
    },
  },
  fa: {
    locale: 'fa',
    messages: {
      hello: 'سلام',
      searchPlaceholder: 'جستجو...',
    },
  },
};

export default dictionary;
